import { wrap } from "comlink";

const worker = new Worker(new URL("./worker.ts", import.meta.url));
const { runBigTask, selectReducerr } =
  wrap<import("./worker").RunBigTask>(worker);

export { runBigTask, selectReducerr };
